import { SALES_ITEM_TYPE, SelectedSalesItemsCar } from 'noddi-types';
import { compareLicensePlates } from 'noddi-util';
import { useBookingActions, useBookingCars, useBookingSelectedSalesItemsCars } from '../bookingStore';
import { FleetCarSelectionButton } from '../Services/FleetCarSelectionButton';

interface MultipleCarSelectionBlockProps {
  carsWithTirePickupOptions: SelectedSalesItemsCar[];
  salesItemId: number;
  isWheelPickupRequired: boolean;
  isAddonsAvailable: boolean;
  priceFormatted: string;
  mutuallyExclusiveSalesItemIds: number[];
}

export const MultipleCarSelectionBlock = ({
  carsWithTirePickupOptions,
  priceFormatted,
  salesItemId,
  isWheelPickupRequired,
  isAddonsAvailable,
  mutuallyExclusiveSalesItemIds
}: MultipleCarSelectionBlockProps) => {
  const cars = useBookingCars();
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();

  const { removeSalesItems, addSalesItems } = useBookingActions();

  function onSelect({
    e,
    car,
    isAlreadySelected
  }: {
    e: React.MouseEvent<HTMLButtonElement>;
    car: SelectedSalesItemsCar;
    isAlreadySelected: boolean;
  }) {
    const params = [
      {
        licensePlate: car.licensePlate,
        salesItemId,
        type: SALES_ITEM_TYPE.TIRE_HOTEL_PICKUP,
        mutuallyExclusiveSalesItemIds,
        isAddonsAvailable,
        isWheelPickupRequired,
        bookingCategorySlug: car.bookingCategorySlug
      }
    ];
    e.stopPropagation();

    isAlreadySelected ? removeSalesItems(params) : addSalesItems(params);
  }

  return (
    <div className='flex flex-col gap-2'>
      {carsWithTirePickupOptions.map((car) => {
        const isSelected = selectedSalesItemsCars.some(
          (item) => compareLicensePlates(item.licensePlate, car.licensePlate) && item.salesItemId === salesItemId
        );

        const carInfo = cars.find((item) => compareLicensePlates(item.licensePlate, car.licensePlate));
        return (
          <FleetCarSelectionButton
            key={car.licensePlate.number}
            isSelected={isSelected}
            onClick={(event) => onSelect({ e: event, car, isAlreadySelected: isSelected })}
            make={carInfo?.make}
            model={carInfo?.model}
            licensePlateNumber={car.licensePlate.number}
            price={priceFormatted}
          />
        );
      })}
    </div>
  );
};
